import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./AuthLoginModal.html';
import styles from './AuthLoginModal-hashed.scss';

var hashedTemplate = cssUtil.hashTemplate(template, styles);

export default ['ModalService', function (ModalService) {
    var modalInstance = null;

    function showModal() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        modalInstance = ModalService.showSimpleDialog(hashedTemplate, data);
    }

    function hideModal() {
        if (!modalInstance) {
            return;
        }

        modalInstance.close();
        modalInstance = null;
    }

    return {
        showModal: showModal,
        hideModal: hideModal
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-auth-angular/components/AuthLoginModal/index.js
// module id = 1326
// module chunks = 0